/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Book_Status_GeneratingInputs */

const en_book_status_generating = /** @type {(inputs: Book_Status_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating`)
};

const es_book_status_generating = /** @type {(inputs: Book_Status_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando`)
};

const fr_book_status_generating = /** @type {(inputs: Book_Status_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génération`)
};

const de_book_status_generating = /** @type {(inputs: Book_Status_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird generiert`)
};

const ja_book_status_generating = /** @type {(inputs: Book_Status_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成中`)
};

const zh_book_status_generating = /** @type {(inputs: Book_Status_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在生成`)
};

const ar_book_status_generating = /** @type {(inputs: Book_Status_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري الإنشاء`)
};

const id_book_status_generating = /** @type {(inputs: Book_Status_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuat`)
};

const it_book_status_generating = /** @type {(inputs: Book_Status_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione in corso`)
};

const ru_book_status_generating = /** @type {(inputs: Book_Status_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание`)
};

const pt_book_status_generating = /** @type {(inputs: Book_Status_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Gerar`)
};

const ko_book_status_generating = /** @type {(inputs: Book_Status_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성 중`)
};

/**
* | output |
* | --- |
* | "Generating" |
*
* @param {Book_Status_GeneratingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const book_status_generating = /** @type {((inputs?: Book_Status_GeneratingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Book_Status_GeneratingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_book_status_generating(inputs)
	if (locale === "es") return es_book_status_generating(inputs)
	if (locale === "fr") return fr_book_status_generating(inputs)
	if (locale === "de") return de_book_status_generating(inputs)
	if (locale === "ja") return ja_book_status_generating(inputs)
	if (locale === "zh") return zh_book_status_generating(inputs)
	if (locale === "ar") return ar_book_status_generating(inputs)
	if (locale === "id") return id_book_status_generating(inputs)
	if (locale === "it") return it_book_status_generating(inputs)
	if (locale === "ru") return ru_book_status_generating(inputs)
	if (locale === "pt") return pt_book_status_generating(inputs)
	return ko_book_status_generating(inputs)
});